'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import { CustomRegistration } from '@components/CustomRegistration';
import ParallaxBlock from '@components/ParallaxBlock';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
export const WIMBLEDON_BRIDGE_REGISTRATION_ID = 'wimbledonBridgeRegistrationID';
export default function WimbledonBridgeRegistration(props: any) {
  const { locale, links, leadConfig } = props;
  return (
    <Stack component="section" className={cn.wimbledonBridgeRegistration}>
      <Box className={cn.wimbledonRegistrationInner}>
        <Box className={cn.wimbledonRegistrationHeader}>
          <ParallaxText
            variant="h4"
            animationType="zoomIn"
            animationDuration={500}
          >
            {ReactHtmlParser(
              props.locale.section['wimbledonBridgeRegistrationHeading']
            )}
          </ParallaxText>
        </Box>
        <Box className={cn.wimbledonRegistrationBody}>
          <CommonContainer maxWidth={{ xs: '100%', md: '1200px' }} flexGrow={1}>
            <Box className={cn.wimbledonRegistrationBlock}>
              <Box className={cn.wimbledonRegistrationContent}>
                <Box className={cn.wimbledonRegistrationContent__title}>
                  <ParallaxText
                    variant="h3"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      props.locale.section[
                        'wimbledonBridgeRegistrationSubHeader'
                      ]
                    )}
                  </ParallaxText>
                </Box>
                <Box className={cn.wimbledonRegistrationContent__data}>
                  <ParallaxText
                    variant="p"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      props.locale.section['wimbledonBridgeRegistrationContent']
                    )}
                  </ParallaxText>
                </Box>
              </Box>
              <Box className={cn.wimbledonRegistrationForms}>
                <CustomRegistration
                  t={locale.section}
                  scrollId={WIMBLEDON_BRIDGE_REGISTRATION_ID}
                  successPopUpLink={links.successPopupRedirection}
                  privacyPolicyLink={links.privacyPolicy}
                  termsAndConditionsLink={links.termsAndConditions}
                  formId={leadConfig.formId}
                  formType={leadConfig.formType}
                  projectName={leadConfig.projectName}
                  variant="modal"
                  className={cn.wimbledonBridgeOuter}
                  listClassName={cn.wimbledonBridgeList}
                  elementClassName={cn.wimbledonBridgeElement}
                  inputClassName={cn.wimbledonBridgeInput}
                  submitBlockClassName={cn.wimbledonBridgeSubmitBlock}
                  submitClassName={cn.wimbledonBridgeButton}
                  wrapperClassName={cn.wimbledonBridgeSuccessWrapper}
                  contentClassName={cn.wimbledonBridgeSuccessContent}
                  buttonClassName={cn.wimbledonBridgeSuccessButton}
                />
              </Box>
            </Box>
          </CommonContainer>
        </Box>
      </Box>
    </Stack>
  );
}
